<template >
  <div class="expert">
    <childLogo></childLogo>
    <el-row class="container">
      <div class="navbar-dark">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">作品评分</span>
          </div>
        </div>
        <div style="font-size: 21px;margin: 15px;color: #5e5e5e;text-align: center">{{siteName}}</div>
      </div>
    </el-row>
    <el-row class="news-center out">
      <el-row class="container">
      <el-form>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <el-form-item label="赛区" style="margin-top: 2%;">
          <el-select
            @change="initGetList"
            filterable
            v-model="queryParams.divisionId"
            placeholder="请选择赛区"
            class="Statistics">
            <el-option
              v-for="item in divisionIdList"
              :key="item.divisionId"
              :label="item.name"
              :value="item.divisionId"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <el-form-item label="作品类型" prop="labelName" style="margin-top: 2%;">
          <el-select
            @change="initGetList"
            filterable
            v-model="queryParams.formType"
            placeholder="请选择作品类型"
            class="Statistics">
            <el-option
              v-for="item in workTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <el-form-item label="流程类型" style="margin-top: 2%;" class="stItems">
          <el-select
            @change="initGetList"
            filterable
            v-model="queryParams.flowId"
            placeholder="请选择流程类型"
            class="Statistics">
            <el-option
              v-for="item in flowList"
              :key="item.node.flowId"
              :label="item.node.label"
              :value="item.node.flowId"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-col>
      </el-form>
      </el-row>
      <el-tabs
        v-model="activeName"
        style="margin-top: 15px;"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :label="'未评审作品'"
          name="UnreviewedWorks"
        >
          <el-row class="container">
            <div style="margin: 10px 0px;"><a href="../static/doc/专家评审流程.pdf" target="_black">专家评审作品流程演示-PDF</a></div>
            <el-table
              :default-sort = "{prop: 'id', order: 'descending'}"
              v-if="tableFalg" v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center"/>
              <el-table-column prop="id" label="作品编号" sortable></el-table-column>
              <el-table-column :show-overflow-tooltip="true"   :key="field.id" v-for="field in fieldList" :label="field.labelName" :prop="field.labelField"
                               v-if="!(field.fieldType=='upload'||field.fieldType=='breakpointUpload')&&field.show">
                <template slot-scope="scope">
                  {{
                    field.type ? scope.row.data[field.labelField + field.labelField + 'Val'] : scope.row.data[field.labelField]
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="score" label="成绩" sortable></el-table-column>
              <el-table-column prop="remark" label="评语" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column width="150"  label="创建时间" align="center" prop="createTime"/>
              <el-table-column label="审核" align="center" width="200px">
                <template slot-scope="scope">
                  <el-row>
                    <el-col :span="24" :key="action.actionId"
                            v-for="action in scope.row.actionList">
                      <el-button
                        icon="el-icon-s-check"
                        size="mini"
                        @click="addFlow(action,scope.row)"
                        type="text"
                      >{{ action.label }}
                      </el-button>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              style="text-align: center"
              v-show="total>0"
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"/>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          :label="'已评审作品'"
          name="ReviewWorks"
        >
          <el-row class="container">
            <el-col style="float:right;margin:10px 0;" :span="1.5" :key="item.node.flowId" v-for="item in flowList">
              <el-button
                :key="action.actionId"
                v-show="isGroup"
                v-if="queryParamsReview.flowId==item.node.flowId"
                v-for="action in item.actionList"
                type="warning"
                size="mini"
                @click="batchReview(action)">
                提交{{ action.label }}
              </el-button>
            </el-col>

          <el-table
            :default-sort = "{prop: 'id', order: 'descending'}"
            v-if="tableFalg" v-loading="loading" :data="ReviewdataList" stripe @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center"/>
            <el-table-column prop="id" label="作品编号" sortable></el-table-column>
            <el-table-column :show-overflow-tooltip="true"   :key="field.id" v-for="field in fieldList" :label="field.labelName" :prop="field.labelField"
                             v-if="!(field.fieldType=='upload'||field.fieldType=='breakpointUpload')&&field.show">
              <template slot-scope="scope">
                {{
                  field.type ? scope.row.data[field.labelField + field.labelField + 'Val'] : scope.row.data[field.labelField]
                }}
              </template>
            </el-table-column>
            <el-table-column prop="score" label="成绩" sortable></el-table-column>
            <el-table-column prop="remark" label="评语" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column width="150"  label="创建时间" align="center" prop="createTime"/>
            <el-table-column label="审核" align="center" width="200px">
              <template slot-scope="scope">
                <el-row>
                  <el-col :span="24" :key="action.actionId"
                          v-for="action in scope.row.actionList">
                    <el-button
                      icon="el-icon-s-check"
                      size="mini"
                      @click="addFlow(action,scope.row)"
                      type="text"
                    >{{ action.label }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
          </el-row>
          <pagination
            style="text-align: center"
            v-if="totalReview > 0"
            :total="totalReview"
            :page.sync="queryParamsReview.pageNum"
            :limit.sync="queryParamsReview.pageSize"
            @pagination="getList"/>
        </el-tab-pane>
      </el-tabs>
<!--      @current-change="handleCurrentChange"-->

      <el-dialog
        :destroy-on-close="true"
        :title="currentFlow.action?
      currentFlow.action.isNotice?`${currentFlow.action.label}(当前操作需要推送消息给相关用户，请填写消息推送信息)`:currentFlow.action.label
      :''"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="flowFalg"
        :width= PcAndPhoneForm>
        <work-form ref="workFormCheck" :workType="getWorkType()" :language="'cn'" @back="back" v-if="flowFalg"
                   :disabled-falg="true"
                   :form-type="queryParams.formType" :form="form" :site-id="siteId" :division-id="divisionId" :workTypeList="workTypeList"></work-form>
        <el-divider v-if="currentFlow.action?currentFlow.action.isNotice:false" content-position="left">推送内容</el-divider>
        <el-form v-if="currentFlow.action?currentFlow.action.isNotice:false" :model="pushFlow" ref="flowForm"
                 label-width="0px" :rules="flowRules">
          <el-form-item label="" prop="pushMsg">
            <el-input type="textarea" v-model="pushFlow.pushMsg" :autosize="{ minRows: 4, maxRows: 4}"
                      placeholder="当前操作需要推送消息给相关用户，请填写消息推送信息"></el-input>
          </el-form-item>
        </el-form>
        <el-form style="margin-left: 15%;">
        <el-form-item prop="remark" label="评语" header-align="center" align="left">
          <el-input type="textarea" v-model="remarks"></el-input>
        </el-form-item>
        <el-form-item label="成绩" align="center">
          <el-input type="text" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" v-model.number="expertSource"></el-input>
        </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-popconfirm  v-if="flowFalg" @onConfirm="addAvoidByMsg()" @confirm="addAvoidByMsg()"
                          title="您确认要执行本次操作吗？">
            <el-button
              :disabled="addFlowFalg"
              style="margin-right: 10px"
              type="danger"
              slot="reference"
              icon="el-icon-s-check">
            回避
          </el-button>
          </el-popconfirm>
        <el-popconfirm  v-if="flowFalg" @onConfirm="addFlowByMsg()" @confirm="addFlowByMsg()"
                        title="您确认要执行本次操作吗？">
          <el-button
            :disabled="addFlowFalg"
            style="margin-right: 10px"
            type="primary"
            slot="reference"
            icon="el-icon-s-check">
<!--            {{ currentFlow.action ? currentFlow.action.label : '' }}-->
            提交
          </el-button>
        </el-popconfirm>
        <el-button @click="handleCloseFlag">取 消</el-button>
      </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'
import Pagination from '@/components/Pagination'
import {listWorksCategoryConf} from '@/api/work/worksCategoryConf'
import {getPowerNode } from '@/api/system/flowNode'
import {listWorkfield} from '@/api/work/workfield'
import {listDataSum, selectContExpertGroupByExpertId, getContWorkDynamicDataFlowVoByIdForAudited, selectWorkCategorySum, listDataReviewSum, updateFlowIdSum, batchUpdateFlowId, updateFlowIdAvoidSum} from '@/api/work/workdata'
import WorkForm from '@/components/workFormDiolog'
import { getUserInfo } from '@/api/register/index'
import {siteMess} from '@/api/system/index'
import { selectExpertGroupDivision } from '../api/work/workdata'
export default {
  name: 'WorkRating',
  components: {
    ChildLogo,
    Pagination,
    WorkForm
  },
  data () {
    return {
      divisionIdList: [],
      siteName: '',
      isMobile: false,
      PcAndPhoneForm: '60%',
      isGroup: false,
      groupId: undefined,
      // 已评审作品的数组
      ids: [],
      totalReview: 0,
      ReviewdataList: [],
      activeName: 'UnreviewedWorks',
      tabName: 'UnreviewedWorks',
      workId: null,
      remarks: '必填项',
      expertSource: '0',
      worksData: {},
      divisionId: null,
      flowFalg: false,
      currentFlow: {},
      rules: {},
      flowRules: {
        pushMsg: [
          { required: true, message: '请输入要推送的内容', trigger: 'blur' }
        ]
      },
      workTypeList: [],
      batchReviewFalg: true,
      addFlowFalg: false,
      flowList: [],
      pushFlow: {
        pushMsg: ''
      },
      tableFalg: true,
      disabledFalg: false,
      fieldList: [],
      // 遮罩层
      loading: true,
      channelId: undefined,
      expertId: undefined,
      // 修改结果集合
      editList: [],
      markType: undefined,
      // 评分方式
      notice: {},
      // 当前大赛当前专家需要评审的表格数据
      tableData: [],
      // 大赛作品申报动态数据表格数据
      dataList: [],
      // 表格数据总数
      total: 0,
      // 表单
      form: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        siteId: null,
        formType: '',
        divisionId: '',
        flowId: null
      },
      queryParamsReview: {
        id: undefined,
        pageNum: 1,
        pageSize: 10,
        siteId: null,
        formType: '',
        divisionId: null,
        flowId: null
      }
    }
  },
  async created () {
    siteMess(this.siteURL, this.siteId).then(res => {
      this.siteName = res.data.name
    })
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (mobile) {
      this.isMobile = false
      this.PcAndPhoneForm = '95%'
    } else {
      this.isMobile = true
    }
    // this.getRoles();
    this.getNoticeContent()
    /* 获取专家赛区 */
    var url = this.siteURL + '/actuator/expert/getInfoByExpert'
    this.axios
      .get(url, { params: { userId: this.$store.state.user.userId } })
      .then((response) => {
        if (response.data.code === 200) {
          this.expertId = response.data.data.id
          selectExpertGroupDivision(this.siteURL, this.expertId, this.siteId).then((res) => {
            this.divisionIdList = res.data
            this.queryParams.divisionId = res.data[0].divisionId
            this.groupId = res.data[0].id
            this.getRoles()
          })
        }
      })
    /* 根据id获取专家id */
    /* var url = this.siteURL + "/actuator/expert/getInfoByExpert";
    this.axios
      .get(url, { params: { userId: this.$store.state.user.userId } })
      .then((response) => {
        if (response.data.code === 200) {
          this.expertId = response.data.data.id;
            debugger
          selectContExpertGroupByExpertId(this.siteURL,this.expertId,this.siteId).then((res)=>{
            this.divisionId = res.data.divisionId;
            this.queryParams.siteId = this.siteId;
            this.queryParams.divisionId = res.data.divisionId
            this.queryParams.userId = this.$store.state.user.userId;
            this.queryParamsReview.siteId = this.siteId;
            this.queryParamsReview.divisionId = this.divisionId;
            this.queryParamsReview.userId = this.$store.state.user.userId;
            this.groupId = res.data.id;
            this.getRoles();
          })
        }
      }); */
    /* 查询评分方式 */
    var urlRule = this.siteURL + '/actuator/rule/getInfoBYSiteId'
    this.axios
      .get(urlRule, { params: { siteId: this.siteId } })
      .then((response) => {
        if (response.data.code === 200) {
          this.markType = response.data.data.ruleId
        }
      })
    this.queryParams.siteId = this.siteId
    this.queryParams.divisionId = this.divisionId
    this.queryParams.userId = this.$store.state.user.userId
    this.queryParamsReview.siteId = this.siteId
    this.queryParamsReview.divisionId = this.divisionId
    this.queryParamsReview.userId = this.$store.state.user.userId
    await listWorksCategoryConf(this.baseURL, {
      siteId: this.siteId
    }).then(res => {
      this.workTypeList = res.rows
      if (this.workTypeList.length === 0) {
        this.loading = false
        this.$message.info('当前站点尚未配置作品类型或您没用权限操作,请联系管理员')
        return
      }
      this.queryParams.formType = this.workTypeList[0].id
    })
    await getPowerNode(this.systemURL, this.siteId).then(nodeRes => {
      this.flowList = nodeRes.data
    }).catch(error => {
      console.log(error)
      this.loading = false
    })
    if (!this.flowList) {
      this.loading = false
      this.$message.info('当前站点没有配置流程信息，无法进行审核操作')
      return
    }
    if (this.flowList.length === 0) {
      this.loading = false
      this.$message.info('当前站点没有配置流程信息，无法进行审核操作')
      return
    }
    if (!this.queryParams.flowId) {
      this.queryParams.flowId = this.flowList[0].node.flowId
      this.queryParamsReview.flowId = this.queryParams.flowId
      this.getList()
    }
  },
  methods: {
    getRoles () {
      var api = this.authURL + '/ruoyi-site/actuator/expertGroup/selectByGroup?contExpertGroupId=' + parseInt(this.groupId) + '&contExpertId=' + parseInt(this.expertId)
      this.axios.get(api, {}).then(res => {
        if (res.data.data.isGroup === 1) {
          this.isGroup = false
        } else {
          this.isGroup = true
        }
      })
    },
    handleCloseFlag () {
      this.flowFalg = false
      this.getList()
    },
    handleClick (tab, event) {
      this.tabName = tab.name
    },
    //  分页参数改变查询数据
    handleCurrentChange (val) {
      if (this.tabName === 'UnreviewedWorks') {
        this.queryParams.pageNum = val
      } else {
        this.queryParamsReview.pageNum = val
      }
      this.getList()
    },
    initGetList () {
      this.queryParams.pageNum = 1
      this.getList()
    },
    async addFlow (action, row) {
      this.expertReviewTime = {
        siteId: this.siteId,
        userId: this.$store.state.user.userId,
        actionId: action.actionId,
        workId: row.id
      }
      if (row.nodeList[0].nodeType === 'file-check') {
        this.$message(
          {
            message: '您的作品不符合规则，进行操作前请按照审核意见重新修改作品，具体情况请查看个人消息',
            type: 'info',
            customClass: 'mzindex' }
        )
      }
      this.expertReviewTime = {
        siteId: this.siteId,
        userId: this.$store.state.user.userId,
        actionId: action.actionId,
        workId: row.id
      }
      await getContWorkDynamicDataFlowVoByIdForAudited(this.siteURL, this.expertReviewTime).then(res => {
        this.flowFalg = true
        var actionAry = res.data.actionList.filter(a => {
          return a.actionId === action.actionId
        })
        if (actionAry.length === 0) {
          this.$message.info('当前作品流程发生变化，请刷新后重试')
          this.initView()
          return
        }
        var url = this.siteURL + '/actuator/workExport/selectGradeByExpertIdAndWorkId'
        this.axios.post(url, {workId: row.id, exportId: this.expertId}).then((response) => {
          this.expertSource = response.data.grade
          this.remarks = response.data.remark
        })

        this.currentFlow.action = action
        this.currentFlow.row = res.data
        this.pushFlow.pushMsg = ''
        let data = res.data.workDynamicData.data
        this.worksData = res.data.workDynamicData
        this.form = JSON.parse(data)
        this.form.siteId = res.data.workDynamicData.siteId
        this.form.userId = res.data.workDynamicData.userId
        this.form.id = res.data.workDynamicData.id
        this.form.divisionId = res.data.workDynamicData.divisionId
        this.workId = res.data.workDynamicData.id
        this.title = '修改大赛作品申报动态数据'
      })
      this.$refs.workFormCheck.hideBuuton()
    },
    initView () {
      this.flowFalg = false
      this.getList()
    },
    addFlowByMsg () {
      console.log('this.$refs.flowForm')
      console.log(this.$refs.flowForm)
      if (this.$refs.flowForm) {
        this.addFlowFalg = true
        console.log('进入校验')
        this.$refs.flowForm.validate((valid) => {
          if (valid) {
            console.log('校验通过')
            this.updateFlow(true).then(() => {
              this.$message.success('操作成功')
              console.log('审核通过')
              this.initView()
            }).catch((error) => {
              this.$message.error('流程信息提交出错，请联系管理员')
              this.initView()
            })
          } else {
            console.log('校验失败')
            this.addFlowFalg = false
          }
        })
      } else {
        console.log('跳过校验')
        this.updateFlow(false).then(() => {
          console.log('执行成功')
          this.$message.success('操作成功')
          this.initView()
        }).catch((error) => {
          this.$message.error('流程信息提交出错，请联系管理员')
          this.initView()
        })
      }
    },
    addAvoidByMsg () {
      if (this.$refs.flowForm) {
        this.addFlowFalg = true
        this.$refs.flowForm.validate((valid) => {
          if (valid) {
            this.updateAvoid(true).then(() => {
              this.$message.success('操作成功')
              this.initView()
            }).catch((error) => {
              this.$message.error('流程信息提交出错，请联系管理员')
              console.log(error)
              this.initView()
            })
          } else {
            this.addFlowFalg = false
          }
        })
      } else {
        this.updateAvoid(false).then(() => {
          this.$message.success('操作成功')
          this.initView()
        }).catch((error) => {
          this.$message.error('流程信息提交出错，请联系管理员')
          console.log(error)
          this.initView()
        })
      }
    },
    updateFlow (falg) {
      console.log('执行审核')
      return new Promise((resolve, reject) => {
        updateFlowIdSum(this.siteURL, {
          workDynamicData: {
            id: this.currentFlow.row.workDynamicData.id,
            flowId: this.currentFlow.action.targetId,
            sourceId: this.currentFlow.action.sourceId,
            expertId: this.expertId
          },
          msgDomain: {
            isNotice: falg, // 是否发送通知
            msg: this.pushFlow.pushMsg, // 消息内容
            sourceId: this.currentFlow.action.sourceId, // 源节点id
            targetId: this.currentFlow.action.targetId, // 目标节点id
            siteId: this.siteId, // 站点id
            senderName: this.name, // 用户名
            type: 4, // 作品消息提醒
            authorId: this.form.userId, // 作品用户id
            workId: this.form.id, // 作品id
            userId: this.$store.state.user.userId
          },
          contWorkExport: {
            grade: this.expertSource,
            remark: this.remarks,
            sort: 1,
            workId: this.workId,
            exportId: this.expertId
          },
          expertReviewTime: this.expertReviewTime
        }).then(res => {
          console.log('执行成功')
          this.addFlowFalg = false
          resolve()
        }).catch(e => {
          reject()
          this.addFlowFalg = false
        })
      })
    },
    updateAvoid (falg) {
      return new Promise((resolve, reject) => {
        updateFlowIdSum(this.siteURL, {
          workDynamicData: {
            id: this.currentFlow.row.workDynamicData.id,
            flowId: this.currentFlow.action.targetId,
            sourceId: this.currentFlow.action.sourceId,
            expertId: this.expertId
          },
          msgDomain: {
            isNotice: falg, // 是否发送通知
            msg: this.pushFlow.pushMsg, // 消息内容
            sourceId: this.currentFlow.action.sourceId, // 源节点id
            targetId: this.currentFlow.action.targetId, // 目标节点id
            siteId: this.siteId, // 站点id
            senderName: this.name, // 用户名
            type: 4, // 作品消息提醒
            authorId: this.form.userId, // 作品用户id
            workId: this.form.id, // 作品id
            userId: this.$store.state.user.userId
          },
          contWorkExport: {
            grade: -1,
            remark: '该专家因回避原则已放弃评审',
            sort: 1,
            workId: this.workId,
            exportId: this.expertId
          },
          expertReviewTime: this.expertReviewTime
        }).then(res => {
          this.addFlowFalg = false
          resolve()
        }).catch(e => {
          reject()
          this.addFlowFalg = false
        })
      })
    },
    getWorkType () {
      let obj = this.workTypeList.filter((w) => {
        return w.id === this.queryParams.formType
      })
      return obj[0]
    },
    back (falg) {
      this.open = falg
      this.getList()
    },
    /** 查询大赛作品申报动态数据列表 */
    async getList (notInit) {
      if (!this.queryParams.flowId) {
        this.$message.error('当前站点没有流程信息')
        this.loading = false
        return
      }
      this.queryParamsReview.flowId = this.queryParams.flowId
      this.queryParamsReview.divisionId = this.queryParams.divisionId
      this.dataList = []
      await this.getFieldList().then(() => {
        this.loading = true
        listDataSum(this.siteURL, { ...this.queryParams, 'categoryId': this.queryParams.formType }).then(response => {
          let dictFields = this.fieldList.filter(field => {
            return field.type
          })
          response.rows.forEach(item => {
            let obj = {}
            obj = item.workDynamicData
            obj.data = JSON.parse(obj.data)
            this.expertSource = item.workDynamicData.score
            this.remarks = item.workDynamicData.remark
            dictFields.forEach(d => {
              let dicAry = this.interpretObj[d.type].filter(dict => {
                return dict.dictValue === obj.data[d.labelField]
              })
              if (dicAry.length > 0) {
                obj.data[d.labelField + d.labelField + 'Val'] = dicAry[0].dictLabel
              }
            })
            obj.actionList = item.actionList
            obj.nodeList = item.nodeList
            this.dataList.push(obj)
          })
          this.total = response.total
          this.tableFalg = true
          this.loading = false
        })
      })
      await this.getFieldListReview().then(() => {
        this.loading = true
        listDataReviewSum(this.siteURL, {
          ...this.queryParamsReview,
          categoryId: this.queryParams.formType
        }).then((response) => {
          let dictFields = this.ReviewFieldList.filter((field) => {
            return field.type
          })
          let ReviewdataListData = []
          response.rows.forEach((item) => {
            let obj = {}
            obj = item.workDynamicData
            obj.data = JSON.parse(obj.data)
            this.expertSource = item.workDynamicData.score
            this.remarks = item.workDynamicData.remark
            dictFields.forEach((d) => {
              let dicAry = this.interpretObj[d.type].filter((dict) => {
                return dict.dictValue === obj.data[d.labelField]
              })
              if (dicAry.length > 0) {
                obj.data[d.labelField + d.labelField + 'Val'] =
                  dicAry[0].dictLabel
              }
            })
            obj.actionList = item.actionList
            obj.nodeList = item.nodeList
            ReviewdataListData.push(obj)
            this.expertId = response.rows[0].workDynamicData.expertId
            // 把查询出来的ID放到数组中
            if (notInit !== 'cancel' && obj.status !== 1) {
              this.ids.push(obj.id)
            }
          })
          this.ReviewdataList = ReviewdataListData
          this.totalReview = response.total
          this.sum = this.total + this.totalReview
          this.tableFalg = true
          this.loading = false
        })
      })
    },
    getFieldList () {
      return new Promise((resolve, reject) => {
        listWorkfield(this.siteURL, {
          siteId: this.siteId,
          formType: this.queryParams.formType
        }).then(res => {
          this.fieldList = res.rows
          if (this.fieldList.length === 0) {
            this.tableFalg = false
            this.$message({
              message: '此站点尚未配置作品申报表单信息',
              type: 'info',
              duration: 1000
            })
          } else {
            this.fieldList.forEach(item => {
              if (item.type) {
                // 此处是为了判断多个字段用一个字典重复查询
                if (!this.interpretObj[item.type]) {
                  this.getDicts(this.systemURL, item.type).then(res => {
                    this.interpretObj[item.type] = res.data
                  })
                }
              }
            })
          }
          resolve()
        })
      })
    },
    // 多选框选中数据
    handleSelectionChange (selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
      this.batchReviewFalg = !selection.length
    },
    // 批量审核
    batchReview (action) {
      if (this.ids) {
        if (this.ids.length === 0) {
          this.$message.error('没有选中数据！')
          return
        }
        this.$confirm('是否确认批量审核作品编号为"' + this.ids + '"的数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let voAry = []
          this.ids.forEach(workId => {
            voAry.push({
              workDynamicData: {
                id: workId,
                flowId: action.targetId,
                sourceId: action.sourceId
              },
              msgDomain: {
                isNotice: action.isNotice, // 是否发送通知
                msg: '', // 消息内容
                sourceId: action.sourceId, // 源节点id
                targetId: action.targetId, // 目标节点id
                siteId: this.siteId, // 站点id
                senderName: this.name, // 用户名
                type: 4, // 作品消息提醒
                // authorId:this.form.userId,//作品用户id
                workId: workId, // 作品id
                userId: this.$store.state.user.userId,
                flowId: this.queryParams.flowId
              }
            })
          })
          return batchUpdateFlowId(this.siteURL, voAry)
        }).then(res => {
          this.$message.success('批量审核成功')
          this.initView()
        }).catch(e => {
          this.$message.error('批量审核失败，请联系管理员')
          this.initView()
        })
      }
    },
    /** 动态获取名称 */
    getNoticeContent () {
      var url = encodeURI(
        this.siteURL +
          '/actuator/channel/list?siteId=' +
          this.siteId +
          '&url=' +
          this.$route.path
      )
      this.axios.get(url, {}).then((response) => {
        this.notice = response.data.rows[0]
        this.channelId = response.data.rows[0].id
      })
    },
    /** 单元格编辑失去焦点事件 */
    handleInputBlur (data) {
      /** 判断是否已保存再编辑数组中 */
      var number = this.editList.indexOf(data)
      if (number !== -1) {
        this.editList[number] = data
      } else {
        this.editList.push(data)
      }
    },
    getFieldListReview () {
      return new Promise((resolve, reject) => {
        listWorkfield(this.siteURL, {
          siteId: this.siteId,
          formType: this.queryParams.formType
        }).then((res) => {
          this.ReviewFieldList = res.rows
          if (this.ReviewFieldList.length === 0) {
            this.tableFalg = false
            this.$message({
              message: this.languageName === 'cn' ? '此站点尚未配置作品申报表单信息' : 'This site has not yet configured the work declaration form information',
              type: 'info',
              duration: 1000
            })
          } else {
            this.ReviewFieldList.forEach((item) => {
              if (item.type) {
                // 此处是为了判断多个字段用一个字典重复查询
                if (!this.interpretObj[item.type]) {
                  this.getDicts(this.systemURL, item.type).then((res) => {
                    this.interpretObj[item.type] = res.data
                  })
                }
              }
            })
          }
          resolve()
        })
      })
    },
    reset () {
      this.form = {
        id: undefined,
        workId: undefined,
        exportId: undefined,
        grade: undefined,
        status: '0',
        remark: undefined,
        sort: undefined,
        createTime: undefined,
        createBy: undefined,
        updateTime: undefined,
        updateBy: undefined,
        delFlag: undefined,
        contWorkExportList: [],
        contWorkRecordList: [],
        markType: undefined
      }
    }
  }
}
</script>
<style>
.expert .el-button--warning{
  background-color: rgb(79, 84, 221);
}
.expert .el-table th {
  background-color: rgb(79, 84, 221);
  color: white;
  text-align: center;
}
.expert .el-table .cell {
  text-align: center;
}
.expert .el-tabs__nav {
  float: none !important;
  z-index: 0;
}
.expert .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
  background-color: #e4e7ed;
  z-index: 1;
}
.expert .el-tabs__active-bar {
  height: 0px;
  background-color: white;
}
.expert .el-tabs__item {
  padding: 0 20px !important;
  margin: 10px 15px;
  border: solid 1px #6192f5;
  font-size: 18px;
  line-height: 35px;
  color: #6192f5;
  border-radius: 5px;
}
.expert .el-tabs__item.is-active {
  color: white;
  background: #6192f5;
}
.expert .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #dbebff;
}
.expert .el-table--fit {
  min-height: 530px;
}
.expert .el-tabs__header {
  text-align:center;
}

</style>
<style scoped>

.out {
  min-height: 450px;
}
.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 80%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 10%;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}
/* 通知公告基础模块 */
.trends {
  min-height: 80px;
}
/* 通知公告竖线样式 */
.trends-line {
  float: left;
  width: 5px;
  height: 40px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 10px;
  margin-bottom: 10px;
}
.trends-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 10px;
  line-height: 40px;
}
.trends-text-cn {
  font-size: 24px;
}
.trends-text-en {
  font-size: 15px;
  color: #666666;
}
.title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 边框样式 */
.box-boder {
  border-bottom: 1px solid #666666;
}

/* 通知公告内容基础样式 */
.trends-notice {
  padding-bottom: 30px;
  background-color: #f5f5f5;
  color: #666666;
}

.Statistics{
  width: 60%;
}

@media screen and (max-width:800px){
  .Statistics{
    width: 100%;
    }

  .stItems{
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/WorkRating.vue